import { parse } from 'querystring'

export function fromSearch (search: string) {
  return parse(search.replace(/^\?/, ''))
}